import React from "react";
import Book_today_image from "../../../../assets/Book_Today_image.png";

import Classes from "./Style.module.css";

const Index = () => {
  return (
    <div className={Classes.section5}>
      <div className={`${Classes.book_direct_container}`}>
        <div className={`${Classes.Book_Direct_Details_Primary}`}>
          Book Today
        </div>
        <div className={`${Classes.Book_Direct}`}>
          <div className={`${Classes.Book_Direct_Details}`}>
            <div className={`${Classes.Book_Direct_Details_Secondary}`}>
              Book Direct
            </div>
            <div className={`${Classes.Book_Direct_Details_Tertiary}`}>
              Book directly with us by calling{" "}
              <span style={{ color: "#000" }}>207-261-0947</span>, or by
              visiting the{" "}
              <span style={{ color: "#000", cursor: "pointer" }}>
                Choice website HERE
              </span>
              .
            </div>
            <div className={`${Classes.Book_Direct_Details_Quartiary}`}>
              <img
                src={Book_today_image}
                alt="Book_today_image"
                className={`${Classes.Book_Direct_Details_Quartiary_img}`}
              />
              <p className={`${Classes.Book_Direct_Details_Quartiary_txt}`}>
                Ogunquit River Inn, an Ascend Hotel Collection Member
              </p>
            </div>
          </div>
          <div className={`${Classes.Book_Direct_Reason}`}>
            <div className={`${Classes.Book_Direct_Reason_Primary}`}>
              Why Book Direct?{" "}
            </div>
            <div className={`${Classes.Book_Direct_Reason_Secondary}`}>
              <div>
                <p className={`${Classes.Book_Direct_Reason_list}`}>
                  It’s easier for us to make changes to your reservation.
                </p>
                <p className={`${Classes.Book_Direct_Reason_list}`}>
                  No booking fees when you book direct! No waiting for your
                  waiting confirmation letters to go thru a third party systems.
                </p>
                <p className={`${Classes.Book_Direct_Reason_list}`}>
                  Enjoy talking to a real person here, onsite, about your stay
                  and room preferences.
                </p>
                <p className={`${Classes.Book_Direct_Reason_list}`}>
                  Guests who book direct are eligible for upgrades and enjoy
                  more flexibility over their reservation.
                </p>
                <p className={`${Classes.Book_Direct_Reason_list}`}>
                  Your information stays private.
                </p>
                <p className={`${Classes.Book_Direct_Reason_list}`}>
                  You get to be in charge of your choices.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
